var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.empty)?_c('a-empty',{staticClass:"trend-empty",attrs:{"description":"所选期间暂无新建订单"}}):_c('div',{ref:"chart",staticClass:"trend-chart",attrs:{"role":"img","aria-label":(_vm.currency + "订单数与累计实收趋势")}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }